// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video_list_container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}

.video_list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.video_list_skeleton {
  display: grid;
  grid-template-columns: 30% 30% 30%;
  gap: 30px;
  margin-top: 10px;
  width: 100%;
}
.video_list_skeleton_image {
  width: 100% !important;
  min-height: 200px !important;
}

.video_thumbnail {
  width: 100%;
  cursor: pointer;
  border-radius: 10px 10px 0 0;
  position: relative;
}
.featured_video_component{
  height: 100%;
  cursor: pointer;
}

.video_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  position: relative;
}

.video_title_container {
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 100%;
}

.video_title {
  font-size: 14px;
  font-family: "Lato";
  font-weight: 600;
  text-align: left !important;
  height: 70% !important;
}

.viewed_count_in_videos {
  font-size: 12px;
  font-family: "Lato";
  font-weight: 300;
  padding-top: 10px;
}
.see_more_videos {
  background-color: rgb(0, 173, 238) !important;
  color: white !important;
  width: 350px;
}
.see_more_videos :hover {
  background-color: rgb(0, 173, 238) !important;
  color: white !important;
}
.see_more_container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.video_thumbnail_logo_overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.play_button_overlay_content {
  position: relative;
}
.featured_video_image {
  width: 100% !important;
  object-fit: cover;
  border-radius: 10px;
}
.featured_video_component {
  position: relative;
  height: 100%;
}
.featured_video_thumbnail_overlay_content {
  position: absolute !important;
  background-color: #cecfd2 !important;
  color: #fff;
  display: flex;
  padding: 2%;
  bottom: 20px;
}

.featured_videos_thumbnail_overlay_details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.featured_video_back_ground_container {
  position: absolute;
  background-color: var(--background-theme-color);
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 45%;
  z-index: 1;
}
.featured_video_content {
  display: flex;
  flex-direction: column;
}
.featured_video_content_title_wrapper {
  display: flex;
  height: 45%;
  flex-direction: column;
  gap: 10%;
}
.featured_story_video_title {
  font-weight: 500;
  font-family: kufam;
}
.featured_story_video {
  color: var(--tag-color);
  font-weight: 700;
  font-family: kufam;
}
.featured_story_video_container {
  display: flex !important;
  justify-content: center !important;
  position: relative;
  height: 100%;
}
.featured_video_container {
  display: flex;
  width: 90%;
  z-index: 2;
  position: relative;
  gap: 3%;
  padding-bottom: 5%;
}
.featured_story_video_container_mobile_view {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
}
.featured_video_container_mobile_view {
  position: relative;
  z-index: 1;
  width: 95%;
}
.featured_video_title_container {
  background-color: var(--background-theme-color);
  width: 100%;
  display: flex;
  justify-content: center;
}
.featured_videos_thumbnail_overlay_play_icon {
  width: 20%;
}
.featured_video_overlay_dark_background {
  background-color: "#4c4b4b";
}
.feature_video_text {
  color: #111 !important;
  font-size: 14px;
  font-family: "Lato";
  font-weight: 600;
  text-align: left !important;
}
.join_whatsapp_channel_videos {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55%;
}
.videos_subscribe_button {
  background-color: #ef1d26;
  color: #fff;
  border-radius: 10px;
  width: 50%;
  height: 40px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  cursor: pointer;
}
.videos_subscribe_button_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 40%;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/videos.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".video_list_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.video_list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n}\n.video_list_skeleton {\n  display: grid;\n  grid-template-columns: 30% 30% 30%;\n  gap: 30px;\n  margin-top: 10px;\n  width: 100%;\n}\n.video_list_skeleton_image {\n  width: 100% !important;\n  min-height: 200px !important;\n}\n\n.video_thumbnail {\n  width: 100%;\n  cursor: pointer;\n  border-radius: 10px 10px 0 0;\n  position: relative;\n}\n.featured_video_component{\n  height: 100%;\n  cursor: pointer;\n}\n\n.video_card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 10px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  position: relative;\n}\n\n.video_title_container {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  width: 100%;\n  height: 100%;\n}\n\n.video_title {\n  font-size: 14px;\n  font-family: \"Lato\";\n  font-weight: 600;\n  text-align: left !important;\n  height: 70% !important;\n}\n\n.viewed_count_in_videos {\n  font-size: 12px;\n  font-family: \"Lato\";\n  font-weight: 300;\n  padding-top: 10px;\n}\n.see_more_videos {\n  background-color: rgb(0, 173, 238) !important;\n  color: white !important;\n  width: 350px;\n}\n.see_more_videos :hover {\n  background-color: rgb(0, 173, 238) !important;\n  color: white !important;\n}\n.see_more_container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.video_thumbnail_logo_overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.play_button_overlay_content {\n  position: relative;\n}\n.featured_video_image {\n  width: 100% !important;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.featured_video_component {\n  position: relative;\n  height: 100%;\n}\n.featured_video_thumbnail_overlay_content {\n  position: absolute !important;\n  background-color: #cecfd2 !important;\n  color: #fff;\n  display: flex;\n  padding: 2%;\n  bottom: 20px;\n}\n\n.featured_videos_thumbnail_overlay_details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.featured_video_back_ground_container {\n  position: absolute;\n  background-color: var(--background-theme-color);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 45%;\n  z-index: 1;\n}\n.featured_video_content {\n  display: flex;\n  flex-direction: column;\n}\n.featured_video_content_title_wrapper {\n  display: flex;\n  height: 45%;\n  flex-direction: column;\n  gap: 10%;\n}\n.featured_story_video_title {\n  font-weight: 500;\n  font-family: kufam;\n}\n.featured_story_video {\n  color: var(--tag-color);\n  font-weight: 700;\n  font-family: kufam;\n}\n.featured_story_video_container {\n  display: flex !important;\n  justify-content: center !important;\n  position: relative;\n  height: 100%;\n}\n.featured_video_container {\n  display: flex;\n  width: 90%;\n  z-index: 2;\n  position: relative;\n  gap: 3%;\n  padding-bottom: 5%;\n}\n.featured_story_video_container_mobile_view {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  height: 100%;\n}\n.featured_video_container_mobile_view {\n  position: relative;\n  z-index: 1;\n  width: 95%;\n}\n.featured_video_title_container {\n  background-color: var(--background-theme-color);\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.featured_videos_thumbnail_overlay_play_icon {\n  width: 20%;\n}\n.featured_video_overlay_dark_background {\n  background-color: \"#4c4b4b\";\n}\n.feature_video_text {\n  color: #111 !important;\n  font-size: 14px;\n  font-family: \"Lato\";\n  font-weight: 600;\n  text-align: left !important;\n}\n.join_whatsapp_channel_videos {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 55%;\n}\n.videos_subscribe_button {\n  background-color: #ef1d26;\n  color: #fff;\n  border-radius: 10px;\n  width: 50%;\n  height: 40px;\n  align-items: center;\n  justify-content: space-around;\n  display: flex;\n  cursor: pointer;\n}\n.videos_subscribe_button_wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  height: 40%;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
